import { createLogger } from 'vuex';

const debug = !['production', 'test'].includes(process.env.NODE_ENV) || App.debug;

const exposeStoreOnWindow = (store) => {
  window.$store = store;
};

export const storeGlobalConfig = {
  strict: debug,
  plugins: debug ? [createLogger(), exposeStoreOnWindow] : [exposeStoreOnWindow],
};
